import React, { Component } from 'react';
import { Image } from 'semantic-ui-react';
import worldClockImage from './../../../images/grafix-icon/icon-time-globe.svg'
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
var moment = require('moment');

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext("Clock and Timezone")
    }
})

class Timezone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setTime: moment()
        }
    }
    componentDidMount() {
        this.setState({ setTime: this.props.selectedOrganisation ? moment().tz(this.props.selectedOrganisation.timeZone) : moment() });
        this.updateTime()
    }

    updateTime() {
        setTimeout(() => {
            this.setState({ setTime: this.props.selectedOrganisation ? moment().tz(this.props.selectedOrganisation.timeZone) : moment() })
        }, 1000)
        setInterval(() => {
            this.setState({ setTime: this.props.selectedOrganisation ? moment().tz(this.props.selectedOrganisation.timeZone) : moment() })
        }, 1000 * 30)
    }

    render() {

        return (
            <div className="dropdown-box pad_10">
                <div className="acc-box org-selector">
                    <div className="acc-image" >
                        <Image src={worldClockImage} />
                    </div>
                    {this.state.setTime ?
                        <div className="acc-text w_96"  >
                            <div className="acc-name" >
                                {this.state.setTime.format('LT')}&nbsp;
                            {this.state.setTime.format('z')}
                            </div>
                            <div className="acc-role" >
                                {this.state.setTime.format('ddd')},&nbsp;
                            {this.state.setTime.format('ll')}

                            </div>
                        </div >
                        :
                        null
                    }
                </div >
            </div>
        )
    }
}


export default Timezone;